import gql from 'graphql-tag';

import * as Generated from '../../generated/graphql';
import * as Filter from '../../util/filters';
import * as SelectionManager from '../../util/selectionmanager';
import * as ViewHooks from '../views/hooks';
import {useRunSetProject} from '../views/runSet/hooks';
import {RunSetPart} from '../views/runSet/types';

///// Query definition

export const RUN_SET_SUMMARY_QUERY = gql`
  query RunSetSummary($projectInternalId: ID!, $selections: JSONString!) {
    project(internalId: $projectInternalId) {
      id
      selectedCount: runCount(filters: $selections)
    }
  }
`;

export interface RunSetSummaryQueryData {
  project: {
    id: string;
    selectedCount: number;
  };
}

export function useRunSetSummaryQuery(runSet: RunSetPart) {
  const {projectInternalId} = useRunSetProject(runSet.project);
  const filters = ViewHooks.usePart(runSet.filtersRef);
  const groupSelections = ViewHooks.usePart(runSet.groupSelectionsRef);

  const queryResults = Generated.useRunSetSummaryQuery({
    variables: {
      projectInternalId: projectInternalId ?? '',
      selections: JSON.stringify(
        Filter.toMongo(
          Filter.And([filters, SelectionManager.toRunFilter(groupSelections)])
        )
      ),
    },
    skip: projectInternalId == null,
  });

  return {
    ...queryResults,
    initialLoading: queryResults.loading && !queryResults.data,
  };
}
